import type { SearchCriteria } from '../validate'
import type { Facet } from './type'

export function keywordToFacet(keyword: string, isLocationWord?: boolean): Facet {
  return {
    label: keyword,
    facetKey: `keyword.${keyword}`,
    selected(criteria) {
      const keywords = criteria?.keywords ?? []
      return keywords.includes(keyword)
    },
    add(current) {
      const { keywords: _keywords, ...rest } = current ?? {}
      const keywords = new Set(_keywords ?? [])
      keywords.add(keyword)
      const criteria = { ...rest, keywords: Array.from(keywords) }
      // FIXME: https://github.com/ikyucom/macaron-frontend/issues/3430
      // 拡張検索によって緯度経度検索と解釈され得るキーワード（スポット、駅）の場合は、エリアと競合するケースが多いため検索条件からエリアを削除する
      // なお、複数の競合するキーワードの指定を無効にしたり、逆にエリアを追加したとき競合するキーワードを削除したりできるようにしたいところだが、
      // SearchCriteria はキーワードのタイプ（スポット、駅など）に関する情報を持たないため、SearchCriteria の情報だけでこれらを実現することはできない
      // もしやるのであれば、キーワードとそのタイプを別途 atom で管理する等すれば対応可能だが、現状はそこまでの実装はしていない
      if (isLocationWord) {
        const { largeAreaCode, mediumAreaCode, smallAreaCodes, minimumAreaCodes, ...rest } =
          criteria
        return rest
      }
      return criteria
    },
    remove(current) {
      // 検索条件に radius が残り続けることを防ぐため、キーワードを削除するタイミングで radius が指定されている場合は同時に削除する
      // 本来であれば、スポットや駅など距離検索に利用されるキーワードが削除された場合のみ削除するべきだが、
      // SearchCriteria にはキーワードのタイプに関する情報を持たないため、キーワードが削除された場合は常に削除している
      const { keywords: _keywords, radius, ...rest } = current ?? {}
      const keywords = new Set(_keywords ?? [])
      keywords.delete(keyword)
      if (keywords.size === 0) {
        return rest
      }
      return { ...rest, keywords: Array.from(keywords) }
    },
    showInList(criteria: SearchCriteria | undefined): boolean {
      return this.selected(criteria)
    },
  }
}
if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  describe('keywordToFacet', () => {
    test('キーワードを追加するとき', () => {
      const criteria = {
        largeAreaCode: '07',
        mediumAreaCode: '002',
        smallAreaCodes: ['001'],
        minimumAreaCodes: ['0094', '0095', '0096'],
        keywords: ['イタリアン'] as string[],
      } as SearchCriteria
      const facet = keywordToFacet('パスタ')
      const result = facet.add(criteria)
      expect(result).toStrictEqual({
        largeAreaCode: '07',
        mediumAreaCode: '002',
        smallAreaCodes: ['001'],
        minimumAreaCodes: ['0094', '0095', '0096'],
        keywords: ['イタリアン', 'パスタ'],
      })
    })
    test('場所を表すキーワードを追加するとき', () => {
      const criteria = {
        largeAreaCode: '07',
        mediumAreaCode: '002',
        smallAreaCodes: ['001'],
        minimumAreaCodes: ['0094', '0095', '0096'],
        keywords: ['イタリアン'] as string[],
      } as SearchCriteria
      const facet = keywordToFacet('東京タワー', true)
      const result = facet.add(criteria)
      expect(result).toStrictEqual({
        keywords: ['イタリアン', '東京タワー'],
      })
    })
    test('キーワードを削除するとき', () => {
      const criteria = {
        keywords: ['イタリアン'] as string[],
        radius: 0.2,
      } as SearchCriteria
      const facet = keywordToFacet('東京タワー')
      const result = facet.remove(criteria)
      expect(result).toStrictEqual({
        keywords: ['イタリアン'],
      })
    })
  })
}
